import { useFetchers, useLoaderData, useNavigation } from 'react-router-dom';
import { LeadActions } from '@/components/LeadActions';
import { LeadMaintenance } from '@/components/LeadMaintenance';
import { LeadNotes } from '@/components/LeadNotes';
import { LeadOdometer } from '@/components/LeadOdometer';
import { LeadParties } from '@/components/LeadParties';
import { LeadWorkflowStepper } from '@/components/LeadWorkflowStepper';
import { useSelectedLead } from '@/hooks/useSelectedLead.ts';
import type { LeadNote } from '@/models/entities/lead';
import { LeadStatusGroups } from '@/models/ui/leadStatusGroup.ts';
import { createStepsModel } from '@/models/ui/steps';

export function LeadDetails() {
  const navigation = useNavigation();
  const fetchers = useFetchers();
  const selectedLead = useSelectedLead();
  const notesHistory = useLoaderData() as LeadNote[];

  if (!selectedLead) {
    return null;
  }
  let hasBusyFetcher = false;
  for (const fetcher of fetchers) {
    if (fetcher.state !== 'idle') {
      hasBusyFetcher = true;
      break;
    }
  }
  const isLoading = navigation.state !== 'idle' || hasBusyFetcher;
  const isLeadInProgress =
    selectedLead.workflow.statusGroup === LeadStatusGroups.InProgress;
  return (
    <div
      className={`transition-all duration-300 ${
        isLoading ? 'opacity-50 pointer-events-none grayscale-[0.2]' : ''
      }`}
    >
      {isLeadInProgress && (
        <LeadWorkflowStepper
          stepsModel={createStepsModel(selectedLead.workflow.status)}
        />
      )}
      <LeadParties selectedLead={selectedLead} />
      <LeadMaintenance
        maintenanceItems={selectedLead.maintenance.maintenanceItems}
      />
      <div className="grid grid-cols-2 gap-4">
        <LeadActions
          key={`actions-${selectedLead.id}`}
          selectedLead={selectedLead}
        />
        <div className="flex flex-col gap-4">
          <LeadNotes
            key={`notes-${selectedLead.id}`}
            notesHistory={notesHistory}
          />
          <LeadOdometer
            key={`odometer-${selectedLead.id}`}
            initialValue={selectedLead.odometer}
          />
        </div>
      </div>
    </div>
  );
}
